import { put, call, takeEvery } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/customerAccount'
import { getCustomerAccounts } from 'services'

const { CUSTOMER_ACCOUNT_REQUEST, CUSTOMER_ACCOUNT_SUCCESS, CUSTOMER_ACCOUNT_ERROR } = ACTION_TYPES

export function *customerAccount() {
  try {
    const response = yield call(getCustomerAccounts)
    yield put({ type: CUSTOMER_ACCOUNT_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: CUSTOMER_ACCOUNT_ERROR, payload: err })
  }
}

export default function *watchCustomerAccount() {
  yield takeEvery(CUSTOMER_ACCOUNT_REQUEST, customerAccount)
}
